module.exports = __webpack_public_path__ + "img/uae2-logo.7866a0ab.png";